import { render, staticRenderFns } from "./PromoterList.vue?vue&type=template&id=25359075&scoped=true&"
import script from "./PromoterList.vue?vue&type=script&lang=js&"
export * from "./PromoterList.vue?vue&type=script&lang=js&"
import style0 from "./PromoterList.vue?vue&type=style&index=0&id=25359075&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25359075",
  null
  
)

export default component.exports